import * as yup from "yup";

export const salaryAdjustSchema = yup.object().shape({
  type: yup.string().required("Required"),
  amount: yup.number().required("Required"),
  description: yup.string().required("Required"),
  month: yup.string().required("Required"),
  year: yup.string(),
  userId: yup.number().required("Required"),
  name: yup.string(),
});

export const salaryEmpInfoSchema = yup.object().shape({
  userName: yup.string().required("Required"),
  salaryPerYear: yup.number().required("Required"),
  email: yup.string().email("Please enter a valid email").required("Required"),
  password: yup.string(),
});

export const salaryAdjustInfo = {
  type: "",
  amount: "",
  description: "",
  month: "",
  year: "",
  userId: "",
  name: "",
};

export const employeeSalaryInfo = {
  userName: "",
  salaryPerYear: "",
  email: "",
  password: "",
};
